/**
 * A number of tile directives to ease rendering of common ui components
 *
 * @author  Mark Cremer <mark@firstcoders.co.uk>
 */
angular.module('pitch.app')
.directive('songwriterGrid',
    function() {
        'use strict';

        return {
            restrict: 'A',
            scope: {
                'songwriters': '=songwriterGrid'
            },
            link: function($scope, elem, attr, ctrl) {
                var widescreenIndexes = [0, 6];

                $scope.isWideImg = function(index) {
                    return widescreenIndexes.indexOf(index) !== -1;
                };
            },
            template:   '<div class="songwriter-grid">' +
                            '<div ng-repeat="article in songwriters track by $index" hover-spy ng-init="::isWide = isWideImg($index); img = (article.assets | asset:isWide ? \'thumbnailXl\' : \'thumbnail\')" ng-class="::isWide ? \'wide col-xs-12 col-md-6\' : \'narrow col-xs-6 col-md-3\'">' +
                                '<div class="aspect-height" ng-class="::isWide ? \'aspect-650-350\' : \'aspect-1-1\'">' +
                                    '<a class="thumbnail container-wrapper" ui-sref="songwriterProfile({id: article.id, name: article.title})">' +
                                        '<div class="image-wrapper animate-scale">' +
                                            '<img alt="[[::img.alt]]" ng-src="[[::img.src]]"></img>' +
                                        '</div>' +
                                        '<div class="caption animate hover-fade-in mask">' +
                                            '<div class="mask-heading mask-heading-lg slide-from-right align-bottom text-box text-box-emphasis" ng-if="::article.title">[[::article.title]]</div>' +
                                        '</div>' +
                                    '</a>' +
                                '</div>' +
                            '</div>' +
                        '</div>'
        };
    }
);



// WEBPACK FOOTER //
// ./src/AppBundle/Resources/js/angular/directives/songwriterGrid.js